import React from 'react';

const StatusIcon = ({ svgRef, ...props }) => (
  <svg xmlnsXlink="http://www.w3.org/1999/xlink" viewBox="0 0 58 53" width="1em" height="1em" fill="currentColor" ref={svgRef} {...props}>
    <defs>
      <path
        id="StatusIcon_a"
        d="M1211.12 16.93c-3.62-.03-7.1 1.4-9.66 3.96a14.48 14.48 0 0 0 0 20.48l21.51 21.52 21.5-21.5a14.48 14.48 0 0 0 0-20.49 13.54 13.54 0 0 0-10.18-3.95 15.28 15.28 0 0 0-10.3 4.53 1.46 1.46 0 0 1-2.05 0 15.28 15.28 0 0 0-10.29-4.55zm11.85 49.5c-.38-.01-.75-.17-1.03-.44l-22.56-22.56c-6.8-6.8-6.8-17.8 0-24.6a16.43 16.43 0 0 1 12.37-4.8c4.14.16 8.1 1.73 11.22 4.44a18.15 18.15 0 0 1 11.22-4.45c4.61-.21 9.1 1.53 12.37 4.8 6.8 6.8 6.8 17.8 0 24.6L1224 65.97c-.27.28-.64.44-1.03.44z"
      />
      <path
        id="StatusIcon_b"
        d="M1216.27 35.64c-.54 0-1.03-.16-1.27-.4l-3.7-3.72-1.11.92c-.25.22-.7.35-1.2.35h-10.7c-.77 0-1.4-.31-1.4-.7 0-.4.63-.72 1.4-.72h9.88l2.01-1.7a2 2 0 0 1 1.26-.34c.52.01.98.16 1.21.4l3.52 3.58 5.24-5.6c.22-.24.66-.4 1.16-.41.5-.02.99.09 1.27.3l5.3 3.77h18.5c.78 0 1.41.32 1.41.71 0 .4-.63.71-1.4.71h-19.25c-.46 0-.9-.1-1.16-.3l-4.27-3.07-5.43 5.82c-.24.24-.73.4-1.26.4z"
      />
    </defs>
    <use xlinkHref="#StatusIcon_a" transform="translate(-1194 -14)" />
    <use xlinkHref="#StatusIcon_b" transform="translate(-1194 -14)" />
  </svg>
);

export default StatusIcon;
